import { render, staticRenderFns } from "./NameCorrection.vue?vue&type=template&id=80859c38&scoped=true&"
import script from "./NameCorrection.vue?vue&type=script&lang=js&"
export * from "./NameCorrection.vue?vue&type=script&lang=js&"
import style0 from "./NameCorrection.vue?vue&type=style&index=0&id=80859c38&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80859c38",
  null
  
)

export default component.exports